/* ============================================================
   DIGMAJE / 記事の目次を本文のH2から自動生成
   ファイル名: assets/dm-article.js
   - 本文（.article-template__content）内の h2 を拾う
   - 各 h2 に id を振る
   - 本文の先頭（最初のh2の直前）に目次を差し込む
   - 本文中に <div data-dm-toc></div> があればそこに差し込む
   - h2 が2つ未満のときは何もしない
   ============================================================ */
(function () {
  'use strict';

  function init() {
    var content = document.querySelector('.article-template__content');
    if (!content) return;

    var headings = content.querySelectorAll('h2');
    if (headings.length < 2) return;

    var list = document.createElement('ol');
    list.className = 'dm-toc__list';

    Array.prototype.forEach.call(headings, function (h, i) {
      if (!h.id) h.id = 'dm-h-' + (i + 1);

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
    });

    var toc = document.createElement('nav');
    toc.className = 'dm-toc';
    toc.setAttribute('aria-label', '目次');

    var head = document.createElement('div');
    head.className = 'dm-toc__head';
    head.textContent = 'INDEX ／ 目次';

    toc.appendChild(head);
    toc.appendChild(list);

    var slot = content.querySelector('[data-dm-toc]');
    if (slot) {
      slot.replaceWith(toc);
    } else {
      content.insertBefore(toc, headings[0]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();